import React from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WeiboIcon,
  WeiboShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import styles from "./styles.module.less";

const { container } = styles;

interface IProps {
  url?: string;
  title?: string;
}

const ShareBundle: React.FC<IProps> = ({
  url = window.location.href,
  title = document.title,
}) => {
  return (
    <div className={container}>
      <TwitterShareButton title={title} url={url}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <TelegramShareButton title={title} url={url}>
        <TelegramIcon size={32} round />
      </TelegramShareButton>
      <WhatsappShareButton title={title} url={url}>
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
      <FacebookShareButton title={title} url={url}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <WeiboShareButton title={title} url={url}>
        <WeiboIcon size={32} round />
      </WeiboShareButton>
      <EmailShareButton title={title} url={url}>
        <EmailIcon size={32} round />
      </EmailShareButton>
    </div>
  );
};

export default ShareBundle;
